// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { FileKind } from "../../../define/FileKind";
import { UIKind } from "../../../define/UIKind";
import { startLinkId } from "../../config/WeChatTriggerTimeLinkConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class OpeningMailLayer extends BasePopUpLayer {

   
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        NormalGameManager._instance.pauseTimer();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.OPENING_MAIL_LAYER);
    }

    onClickStart() {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.OPENING_MAIL_LAYER);
        O1HD.getServices().userSrv.setCoins(200, true);
        NormalGameManager._instance.setGameData({ plotDialogue: true }, false);
        NormalGameManager._instance.resumeTimer();
        let weChatLink = startLinkId;
        NormalGameManager._instance.addOneWeChatTriggerLink(weChatLink);
        utilsView.openPopupLayerTwo(FileKind.PrefabFilePath.outSizePage);
        // NormalGameManager._instance.openCompensateAwardLayer();
        this.destroyNode();
    }

    // update (dt) {}
}
